import "./column-components.e595a3de.js";
import {hyperStyled as $cdtBV$hyperStyled} from "@macrostrat/hyper";
import {format as $cdtBV$format} from "d3-format";
import $cdtBV$reactselect from "react-select";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $76e2a564ce383665$exports = {};

$parcel$export($76e2a564ce383665$exports, "LabeledControl", () => $76e2a564ce383665$export$f9748db7e5fc90f2);
$parcel$export($76e2a564ce383665$exports, "RaisedSelect", () => $76e2a564ce383665$export$ee7a0846eb965877);
$parcel$export($76e2a564ce383665$exports, "IntervalEditorTitle", () => $76e2a564ce383665$export$f9a5bc8171641c49);


var $cJZBk = parcelRequire("cJZBk");


const $76e2a564ce383665$var$h = (0, $cdtBV$hyperStyled)((0, (/*@__PURE__*/$parcel$interopDefault($cJZBk))));
const $76e2a564ce383665$export$f9748db7e5fc90f2 = function(props) {
    const { title: title, children: children, ...rest } = props;
    delete rest.is;
    return $76e2a564ce383665$var$h("div.labeled-control", [
        $76e2a564ce383665$var$h("label.bp3-label", null, [
            $76e2a564ce383665$var$h.if(title != null)("span.label-text", null, title)
        ]),
        props.is != null ? $76e2a564ce383665$var$h(props.is, rest) : null
    ]);
};
const $76e2a564ce383665$var$menuStyles = (provided)=>({
        ...provided,
        zIndex: 999
    });
const $76e2a564ce383665$export$ee7a0846eb965877 = (props)=>$76e2a564ce383665$var$h((0, $cdtBV$reactselect), {
        styles: {
            menu: $76e2a564ce383665$var$menuStyles
        },
        ...props
    });
const $76e2a564ce383665$export$f9a5bc8171641c49 = function(props) {
    let { showID: showID, title: title, interval: interval, heightFormat: heightFormat } = props;
    const { id: id, top: top, bottom: bottom } = interval;
    let fmt = (v)=>v;
    if (heightFormat != null) fmt = (0, $cdtBV$format)(heightFormat);
    if (showID == null) showID = true;
    return $76e2a564ce383665$var$h("div.editor-dialog-title.editor-title", [
        $76e2a564ce383665$var$h("h3.title-center", title),
        $76e2a564ce383665$var$h("h4.height-range", `${fmt(bottom)} \u{2013} ${fmt(top)} m`),
        $76e2a564ce383665$var$h("h4.id", null, [
            "ID: ",
            $76e2a564ce383665$var$h.if(id != null && showID)("code", id)
        ])
    ]);
};


export {$76e2a564ce383665$export$f9748db7e5fc90f2 as LabeledControl, $76e2a564ce383665$export$ee7a0846eb965877 as RaisedSelect, $76e2a564ce383665$export$f9a5bc8171641c49 as IntervalEditorTitle};
//# sourceMappingURL=column-components.cbe585ce.js.map
